

import axios from "axios";
import { decryptionData,datetimenow } from '@/components/utils/utils.js';
import io from 'socket.io-client';
export default {
  name: 'register-public',
  
  data() {
    return {

      socket: "",
      formValid: false,
      fullname: "",
      nik: "",
      department: "",
      username: "",
      email: "",
      mobile: "",
      password: "",
      confirmPassword: "",

      showpassword: false,
      showconfirmpassword: false,
      dialogInfo:false,
      alertFailed:'',
      alert_err_attention:'',
      alertSuccess:'',
      errors: null,

      // VALIDATION RULES
      emailRules: [
        v => !!v || 'Email is required',
        v => /.+@.+\..+/.test(v) || 'Email must be valid'
      ],

      // mobileRules: [
      //   v => !!v || 'Mobile is required',
      //   v => /^[0-9]+$/.test(v) || 'Mobile must be numeric',
      //   v => v.length >= 10 || 'Mobile min 10 digits',
      //   v => v.length <= 15 || 'Mobile max 15 digits'
      // ],

      passwordRules: [
        v => !!v || 'Password is required',
        v => v.length >= 6 || 'Min 6 characters'
      ],

      confirmPasswordRules: [
        v => !!v || 'Confirm Password is required',
        v => v === this.password || 'Password must match'
      ],
    }
  },
  
  mounted() {
    // this.getKeywordRole();
    // this.loadItemsPerson();
    // this.loadItemsOrganization();
  },
  
  methods: {
    validateForm() {
      if (this.$refs.form.validate()) {
        this.postFinishRegister();
      }
    },
    async postFinishRegister() {
      try {
        const res = await axios.post("/registration-pb", {
          department_name: this.department,
          nik: this.nik,
          username: this.username,
          fullname: this.fullname,
          email: this.email,
          mobile: this.mobile,
          password: this.password
        });
        if (res.data.status == 200 || res.data.status == 201) {
          this.dialogInfo = true;

          this.socket = io(process.env.VUE_APP_API_SOCKET); 
          this.socket.emit('message', { 
            type: 'notifikasi_register',//type ini untuk mengategorikan jenis data yg ada di socket.io
            text: 'Username <b>'+this.username+'</b> created register user Medan247',
            username: 'Username',
            url: '/registrasiuser',
            date: datetimenow(),
          });
          // this.btnLoadingFinish = false;
        } else {
          this.alertFailed = true;
          this.alert_err_attention = res.data.msg;
        }

      } catch (e) {
        this.alertFailed = true;
        this.alert_err_attention = "Register Failed";
      }
    }

  }
}